"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTeamMembersFetchedTeamId = exports.getTotalTeamMembers = exports.getTeamMemberById = exports.getTeamMembers = exports.getTeamMembersMap = exports.getTeamMembersIds = exports.getIsTeamMembersIdle = exports.getIsTeamMembersLoaded = exports.getIsTeamMembersLoading = exports.getTeamMembersStatus = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var _teamMembers = require("./teamMembers.reducer");

var getTeamMembersState = function getTeamMembersState(state) {
  return state.modules.campaignSettings.entities.teamMembers;
};

var selectors = _teamMembers.teamMembersAdapter.getSelectors(getTeamMembersState);

var getTeamMembersStatus = (0, _ramda.pipe)(getTeamMembersState, (0, _ramda.prop)('status'));
exports.getTeamMembersStatus = getTeamMembersStatus;
var getIsTeamMembersLoading = (0, _ramda.pipe)(getTeamMembersState, function (state) {
  return state.status === _utils.StateStatus.Pending;
});
exports.getIsTeamMembersLoading = getIsTeamMembersLoading;
var getIsTeamMembersLoaded = (0, _ramda.pipe)(getTeamMembersState, function (state) {
  return state.status === _utils.StateStatus.Fulfilled;
});
exports.getIsTeamMembersLoaded = getIsTeamMembersLoaded;
var getIsTeamMembersIdle = (0, _ramda.pipe)(getTeamMembersState, function (state) {
  return state.status === _utils.StateStatus.Idle;
});
exports.getIsTeamMembersIdle = getIsTeamMembersIdle;
var getTeamMembersIds = selectors.getIds;
exports.getTeamMembersIds = getTeamMembersIds;
var getTeamMembersMap = selectors.getEntities;
exports.getTeamMembersMap = getTeamMembersMap;
var getTeamMembers = selectors.getAll;
exports.getTeamMembers = getTeamMembers;
var getTeamMemberById = selectors.getById;
exports.getTeamMemberById = getTeamMemberById;
var getTotalTeamMembers = selectors.getTotal;
exports.getTotalTeamMembers = getTotalTeamMembers;
var getTeamMembersFetchedTeamId = (0, _ramda.pipe)(getTeamMembersState, (0, _ramda.prop)('teamId'));
exports.getTeamMembersFetchedTeamId = getTeamMembersFetchedTeamId;